import { useMemo } from "react";
import type { TermsOption } from "@stripe/stripe-js";

export const usePaymentElementTerms = (): TermsOption =>
  useMemo(
    () => ({
      card: "never",
      googlePay: "never",
      applePay: "never",
    }),
    [],
  );
